export default defineNuxtRouteMiddleware((to, from) => {
  const config = useRuntimeConfig();
  const layout = config.public.layout;
  const localePath = useLocalePath();
  const isSupplier = layout.type.includes("supplier");
  if (to.path.startsWith("/discover")) {
    if (isSupplier) {
      return navigateTo(localePath("/experiences"));
    } else {
      return navigateTo(localePath("/things-to-do"));
    }
  } else if (to.fullPath == "/experiences") {
    if (!isSupplier) {
      return navigateTo(localePath("/things-to-do"));
    }
  } else if (to.fullPath == "/things-to-do") {
    if (isSupplier) {
      return navigateTo(localePath("/experiences"));
    }
  } else {
    const pathSegments = to.path.split("/").filter(Boolean);
    const languagePrefixes = [
      "en",
      "fr",
      "es",
      "de",
      "ar",
      "ru",
      "tr",
      "az",
      "tu",
      "zh",
    ];
    let citySlug, productSlug;
    const hasLang = languagePrefixes.some(
      (prefix) => pathSegments[0] === prefix
    );
    if (
      (hasLang && pathSegments.length > 2) ||
      (!hasLang && pathSegments.length > 1)
    ) {
      if (hasLang) {
        [, citySlug, productSlug] = pathSegments;
      } else {
        [citySlug, productSlug] = pathSegments;
      }
      if (
        citySlug !== "blog" &&
        citySlug !== "experiences" &&
        citySlug !== "auth" &&
        citySlug !== "about" &&
        citySlug !== "cart" &&
        citySlug !== "checkout" &&
        citySlug !== "terms-and-conditions" &&
        citySlug !== "privacy-policy" &&
        citySlug !== "faq" &&
        citySlug !== "things-to-do" &&
        citySlug !== "search" &&
        !citySlug.startsWith("things-to-do-in")
      ) {
        if (isSupplier) {
          return navigateTo(`/experiences/${productSlug}`);
        } else {
          return navigateTo(`/things-to-do-in-${citySlug}/${productSlug}`);
        }
      }
    }
  }
});
